/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Cancel from '@mui/icons-material/Cancel'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { Chip } from '@mui/material'
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined'
import { fetchScanResults, hideModal } from '../../redux/actions'
import ModalContainer from './ModalContainer'
import { formatDateTime, formatVerificationDocumentType } from '../../formatting'
import StyledLink from '../StyledLink'
import Label from '../@Common/Form/Label/Label'

export function DocScanResultsModal({ verificationRequestId }) {
  const dispatch = useDispatch()

  const [scanResults, setScanResults] = useState(null)
  const [ready, setReady] = useState(false)

  const getScanResults = () => dispatch(fetchScanResults(verificationRequestId))
  const onCancel = () => dispatch(hideModal())

  function getDecisionChipColor(decision) {
    switch (decision?.toUpperCase()) {
      case 'APPROVED':
        return '#1F8623'
      case 'MANUAL_REVIEW':
        return '#F7B918'
      case 'DECLINED':
      case 'ERROR':
        return '#BD2326'
      default:
        return '#666'
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const results = await getScanResults()
      setScanResults(results[0])
      setReady(true)
    }
    fetchData()
  }, [])

  return (
    <ModalContainer
      title="Document Scan Results"
      maxWidth="sm"
      fullWidth="true"
      actions={{
        secondaryAction: {
          label: 'Close',
          onClick: onCancel,
        },
      }}
    >
      {
        ready && !scanResults
        && (
          <div>
            Document not scanned
          </div>
        )
      }
      {
        ready && scanResults
        && (
          <div>
            <Box
              sx={{
                backgroundColor: '#e3e3e3',
                margin: '0px -24px',
                padding: '10px 24px',
                width: 'calc(100% + 48px)',
              }}
            >
              <Grid container spacing={1}>
                <Grid container item spacing={2}>
                  <Grid item xs={3}>
                    <Label>Document Type:</Label>
                  </Grid>
                  <Grid item xs={9}>
                    {formatVerificationDocumentType(scanResults.verificationDocumentType)}
                    <br />
                    {scanResults.documentSubType && scanResults.documentSubType !== 'undefined' && <span style={{ color: '#878a8f' }}>{scanResults.documentSubType}</span>}
                  </Grid>
                </Grid>
                <Grid container item spacing={2}>
                  <Grid item xs={3}>
                    <Label>Date Scanned:</Label>
                  </Grid>
                  <Grid item xs={9}>
                    {formatDateTime(scanResults.scanDateUtc)}
                  </Grid>
                </Grid>
                <Grid container item spacing={2}>
                  <Grid item xs={3}>
                    <Label>Time to Scan:</Label>
                  </Grid>
                  <Grid item xs={9}>
                    {scanResults.timeToScanMilliseconds / 1000.0}
                    {' '}
                    seconds
                  </Grid>
                </Grid>
                {/* <Grid container item spacing={2}>
            <Grid item xs={3}>
              <Label>Result:</Label>
            </Grid>
            <Grid item xs={9}>
              <Label style={{ color: scanResults.passed ? '#1F8623' : '#BD2326' }}>{ scanResults.passed ? 'PASSED' : 'FAILED' }</Label>
            </Grid>
          </Grid> */}
              </Grid>
            </Box>
            {
              scanResults.forensicAnalysisDecision === 'ERROR' && (
                <div>
                  <Label>An error occurred during forensic analysis</Label>
                  <p style={{ color: '#878a8f' }}>This document was not validated.</p>
                </div>
              )
            }

            {scanResults?.forensicResults.length > 0 && (
              <Box sx={{
                border: '1px solid #cfcfcf', overflowWrap: 'anywhere', padding: '11px 24px', mt: '20px',
              }}
              >
                <Grid container justifyContent="space-between" sx={{ marginBottom: '10px' }}>
                  <Grid item><Label>Fraud Analysis</Label></Grid>
                  <Grid item>
                    <Chip
                      label={scanResults.forensicResults[0].decision}
                      size="small"
                      sx={{
                        backgroundColor: getDecisionChipColor(scanResults.forensicResults[0].decision),
                        color: '#fff',
                        height: '20px',
                        fontSize: '12px',
                        borderRadius: '4px',
                      }}
                    />
                  </Grid>
                </Grid>
                <Box sx={{ fontSize: '14px', marginBottom: '10px' }}>
                  <Label>Submission ID:</Label>
                  {' '}
                  {scanResults.forensicResults[0].submissionId}
                </Box>
                <Box sx={{ fontSize: '14px' }}>
                  <Label>Document ID:</Label>
                  {' '}
                  {scanResults.forensicResults[0].documentId}
                </Box>
                <Box sx={{ marginTop: '10px', fontSize: '14px' }}>
                  <StyledLink
                    to={scanResults.forensicResults[0].detailedReportUrl}
                    newWindow
                    contents={(
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <DocumentScannerOutlinedIcon />
                        View Results
                      </span>
                    )}
                  />
                </Box>
              </Box>
            )}

            <Box sx={{
              border: '1px solid #cfcfcf', overflowWrap: 'anywhere', padding: '11px 24px', borderBottom: 'none', mt: '20px',
            }}
            >
              <Grid container justifyContent="space-between" sx={{ marginBottom: '10px' }}>
                <Grid item><Label>Group Eligibility</Label></Grid>
                <Grid item>
                  <Chip
                    label={scanResults.rulesAnalysisDecision}
                    size="small"
                    sx={{
                      backgroundColor: scanResults.rulesAnalysisDecision === 'PASS' ? '#1F8623' : '#BD2326',
                      color: '#fff',
                      height: '20px',
                      fontSize: '12px',
                      borderRadius: '4px',
                    }}
                  />
                </Grid>
              </Grid>
              <div style={{ textAlign: 'right', color: '#878a8f', fontSize: '12px' }}>
                Rule-set applied:
                {scanResults.ruleSetName}
                {' '}
                (
                {scanResults.ruleSetVersion}
                )
              </div>
            </Box>
            {
              !scanResults.items.length && (
                <div>
                  <Label>Document not scanned</Label>
                  <p style={{ color: '#878a8f' }}>This document was not scanned, no matching rule sets were found during scan.</p>
                </div>
              )
            }
            <div>
              <List sx={{ pt: 0 }}>
                {
                  scanResults.items.map((x, i) => (
                    <ListItem
                      key={i}
                      sx={{
                        border: '1px solid #cfcfcf',
                        marginTop: '-1px',
                        overflowWrap: 'anywhere',
                        padding: '11px 24px',
                      }}
                    >
                      <Grid container>
                        <Grid item xs={10} sx={{ color: '#222', lineHeight: '1.25', fontSize: '14px' }}>
                          {x.description}
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                          {
                            x.passed
                              ? <CheckCircle style={{ color: '#1F8623' }} />
                              : <Cancel style={{ color: '#BD2326' }} />
                          }
                        </Grid>
                      </Grid>
                    </ListItem>
                  ))
                }
              </List>
            </div>
          </div>
        )
      }
    </ModalContainer>
  )
}

export default DocScanResultsModal
